import React, { useState } from 'react';
import { useFetch } from 'hooks';
import { routes } from 'constants/config';
import { Icon, Spinner } from 'ui';
import RemoteAutoComplete from 'components/shared/RemoteAutoComplete';
import request from 'utils/request_ajax';
import InfoTooltip from 'components/shared/InfoTooltip';

const Suggestion = ({ name }) => <div>{name}</div>;

const LessonDistributors = ({ lessonId, archived }) => {
  const [waiting, setWaiting] = useState(false);
  const {
    data: lessonDistributors,
    loading,
    initialLoading,
    runRequest,
  } = useFetch(routes.LESSON_OVERVIEW.DISTRIBUTORS(lessonId));
  if (initialLoading) {
    return (
      <div className="d-f ai-c jc-c mb-8">
        <Spinner />
      </div>
    );
  }

  const distributorUniqueIds = lessonDistributors.map(
    distributor => distributor.unique_identifier,
  );

  const filterSuggestions = distributors =>
    distributors.filter(
      distributor =>
        !distributorUniqueIds.includes(distributor.unique_identifier),
    );

  const addDistributor = distributor => {
    setWaiting(true);
    request
      .postJSON(routes.LESSON_OVERVIEW.DISTRIBUTORS(lessonId), {
        distributor_id: distributor.id,
        distributor_ums_uuid: distributor.uuid,
        distributor_type: distributor.type,
      })
      .then(() => {
        runRequest();
        setWaiting(false);
      });
  };

  const removeDistributor = distributor => {
    if (
      /* eslint-disable-next-line no-alert */
      window.confirm(
        t('lessons.distributors.remove_confirmation', {
          name: distributor.name,
        }),
      )
    ) {
      setWaiting(true);
      request
        .delete(
          routes.LESSON_OVERVIEW.DELETE_DISTRIBUTOR(
            lessonId,
            distributor.type,
            distributor.id,
            distributor.uuid,
          ),
        )
        .then(() => {
          runRequest();
          setWaiting(false);
        });
    }
  };

  return (
    <div className="Autocomplete ui-front" id="distributors">
      <h3 className="Module-heading SectionHeading">
        {t('lessons.distributors.title.enabled')}
        <InfoTooltip
          tooltip={t('lessons.distributors.tooltip')}
          className="ml-4 tooltip-fixedWidth Module-headingIcon"
        />
      </h3>
      <section id="distributors_list">
        {waiting ||
          (loading && (
            <div className="d-f ai-c jc-c mt-8">
              <Spinner />
            </div>
          ))}
        <RemoteAutoComplete
          placeholder={t('lessons.distributors.placeholder')}
          className="SidebarModule-input"
          mapResponseToSuggestions={response => response}
          getSuggestionValue={suggestion => suggestion.name}
          renderSuggestion={Suggestion}
          filterSuggestions={filterSuggestions}
          onSuggestionSelected={addDistributor}
          url={routes.LESSON_OVERVIEW.POTENTIAL_DISTRIBUTORS(lessonId)}
        />
        <section id="distributors_list">
          {waiting ||
            (loading && (
              <div className="d-f ai-c jc-c mt-8">
                <Spinner />
              </div>
            ))}
          {lessonDistributors.map(distributor => (
            <article
              className="user owner quicklist-item"
              id={`distributor_user_${distributor.id}`}
              key={distributor.id}
            >
              {distributor.name}

              {!archived && (
                <button
                  type="button"
                  onClick={() => removeDistributor(distributor)}
                  className="quicklist-remove u-resetBtn"
                >
                  <Icon name="remove" />
                </button>
              )}
            </article>
          ))}
        </section>
      </section>
    </div>
  );
};

export default props => <LessonDistributors {...props} />;
